module.exports = __webpack_public_path__ + "img/logo-derecho.8ac71682.png";